<template>
  <v-container id="master-opd" fluid tag="section" class="cyber-page">
    <v-row>
      <v-col cols="12" md="5">
        <base-material-card
          color="#018C74"
          icon="mdi-office-building-cog"
          class="glass-card full-height"
        >
          <template v-slot:heading>
            <div class="display-1 font-weight-black cyber-text">KONFIGURASI UNIT OPD</div>
            <div class="subtitle-2 secondary-text">
              Input Data Organisasi & Lokasi Wilayah
            </div>
          </template>

          <v-form ref="form" class="mt-4">
            <v-row dense>
              <v-col cols="12" class="mb-2">
                <v-switch
                  v-model="editedItem.is_active"
                  :label="`STATUS UNIT: ${
                    editedItem.is_active == 1 ? 'AKTIF' : 'NON-AKTIF'
                  }`"
                  :true-value="1"
                  :false-value="0"
                  color="#018C74"
                  inset
                  hide-details
                ></v-switch>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.nama_opd"
                  label="Nama Unit OPD"
                  outlined
                  color="#018C74"
                  prepend-inner-icon="mdi-bank"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.alamat_kantor"
                  label="Alamat Kantor"
                  outlined
                  color="#018C74"
                  prepend-inner-icon="mdi-map-marker-path"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.deskripsi"
                  label="Deskripsi Operasional"
                  outlined
                  color="#018C74"
                  rows="2"
                />
              </v-col>

              <v-col cols="12" class="mb-4">
                <div class="cyber-sosmed-header mb-2 secondary-text font-weight-bold">
                  <v-icon small color="#CFA22D" class="mr-1"
                    >mdi-share-variant-outline</v-icon
                  >
                  JEJARING SOSIAL OPD
                </div>

                <v-row
                  v-for="(item, index) in editedItem.sosmed"
                  :key="index"
                  dense
                  class="align-center mb-2"
                >
                  <v-col cols="4">
                    <v-select
                      v-model="item.platform"
                      :items="[
                        'facebook',
                        'instagram',
                        'youtube',
                        'twitter',
                        'tiktok',
                        'website',
                      ]"
                      label="Platform"
                      outlined
                      dense
                      color="#018C74"
                      hide-details
                      class="cyber-select-dense"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="item.url"
                      label="Link URL"
                      placeholder="https://..."
                      outlined
                      dense
                      color="#018C74"
                      hide-details
                      class="cyber-input-dense"
                    />
                  </v-col>
                  <v-col cols="2" class="text-center">
                    <v-btn
                      icon
                      color="#ff5252"
                      @click="removeSosmed(index)"
                      small
                      class="glow-on-hover"
                    >
                      <v-icon small>mdi-delete-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-btn
                  small
                  outlined
                  color="#CFA22D"
                  class="mt-1 cyber-add-sosmed-btn"
                  @click="addSosmed"
                >
                  <v-icon left small>mdi-plus-circle-outline</v-icon> Tambah Media Sosial
                </v-btn>
              </v-col>
              <v-col cols="12" md="8">
                <v-file-input
                  label="Unggah Visual Kantor"
                  outlined
                  color="#018C74"
                  prepend-icon=""
                  prepend-inner-icon="mdi-camera-enhance"
                  @change="onFileChange"
                />
              </v-col>
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-expand-transition>
                  <div v-if="imageUrl" class="preview-mini-frame">
                    <v-img
                      :src="imageUrl"
                      height="50"
                      contain
                      class="rounded border-neon"
                    />
                  </div>
                </v-expand-transition>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.latlong"
                  label="Koordinat Geospasial (Lat, Long)"
                  outlined
                  color="#CFA22D"
                  hint="Paste koordinat atau drag marker di peta"
                  persistent-hint
                  prepend-inner-icon="mdi-target-variant"
                  class="cyber-coord-field"
                />
              </v-col>
            </v-row>
            <v-card-actions class="px-0 pt-4">
              <v-btn text color="rgba(255,255,255,0.6)" @click="clearForm">RESET</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="#CFA22D"
                class="cyber-save-btn"
                :loading="loading"
                @click="save"
              >
                <v-icon left>mdi-sync-circle</v-icon> SIMPAN DATA
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="7">
        <base-material-card
          color="#CFA22D"
          icon="mdi-map-search-outline"
          class="glass-card"
        >
          <template v-slot:heading>
            <div class="display-1 font-weight-black white--text">NAVIGASI LOKASI</div>
            <div class="subtitle-2 white--text opacity-7">
              Klik area peta untuk mapping lokasi tepat
            </div>
          </template>
          <div class="map-wrapper">
            <div class="map-corner top-left"></div>
            <div class="map-corner top-right"></div>
            <div id="map-opd" class="cyber-map-container light-map"></div>
          </div>
        </base-material-card>
      </v-col>

      <v-col cols="12">
        <base-material-card
          color="#018C74"
          icon="mdi-database-eye"
          class="glass-card mt-6"
        >
          <template v-slot:heading>
            <v-row align="center" dense>
              <v-col cols="12" md="6">
                <div class="display-1 font-weight-black white--text">ARSIP DATA UNIT</div>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify-scan"
                  label="Cari Unit OPD atau Alamat..."
                  single-line
                  hide-details
                  rounded
                  dense
                  color="#CFA22D"
                  class="cyber-search-field"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>

          <v-data-table
            :headers="headers"
            :items="opdList"
            :search="search"
            :loading="loading"
            class="cyber-table"
          >
            <template v-slot:item.foto="{ item }">
              <div class="table-img-frame">
                <v-img
                  v-if="item.foto"
                  :src="`https://berkah.bondowosokab.go.id:5500/uploads/${item.foto}`"
                  width="50"
                  height="35"
                  cover
                  class="rounded-sm shadow-glow"
                />
                <v-icon v-else color="grey darken-2">mdi-image-off-outline</v-icon>
              </div>
            </template>

            <template v-slot:item.is_active="{ item }">
              <v-chip
                x-small
                outlined
                :color="item.is_active == 1 ? '#018C74' : '#ff5252'"
                class="font-weight-bold"
              >
                {{ item.is_active == 1 ? "ACTIVE" : "INACTIVE" }}
              </v-chip>
            </template>

            <template v-slot:item.nama_opd="{ item }">
              <span class="white--text font-weight-bold">{{ item.nama_opd }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                icon
                color="#018C74"
                @click="editItem(item)"
                class="glow-on-hover mr-2"
              >
                <v-icon small>mdi-circle-edit-outline</v-icon>
              </v-btn>
              <v-btn icon color="#ff5252" @click="deleteItem(item)" class="glow-on-hover">
                <v-icon small>mdi-delete-alert-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    search: "",
    loading: false,
    opdList: [],
    imageFile: null,
    imageUrl: null,
    map: null,
    marker: null,
    headers: [
      { text: "VISUAL", value: "foto", sortable: false, width: "100px" },
      { text: "IDENTITAS OPD", value: "nama_opd" },
      { text: "ALAMAT OPERASIONAL", value: "alamat_kantor" },
      { text: "STATUS", value: "is_active", width: "100px" },
      { text: "KOORDINAT", value: "latlong", class: "secondary-text" },
      { text: "KONTROL", value: "actions", align: "end", sortable: false },
    ],
    editedItem: {
      id: null,
      nama_opd: "",
      deskripsi: "",
      alamat_kantor: "",
      latlong: "",
      is_active: 1,
      sosmed: [],
    },
    defaultItem: {
      id: null,
      nama_opd: "",
      deskripsi: "",
      alamat_kantor: "",
      latlong: "",
      is_active: 1,
      sosmed: [],
    },
  }),

  mounted() {
    this.fetchData();
    this.initMap();
  },

  watch: {
    "editedItem.latlong": function (newVal) {
      if (!newVal) return;
      const coords = newVal.split(",");
      if (coords.length === 2) {
        const lat = parseFloat(coords[0]);
        const lng = parseFloat(coords[1]);
        if (!isNaN(lat) && !isNaN(lng)) {
          const latlng = [lat, lng];
          if (this.marker) {
            const currentPos = this.marker.getLatLng();
            if (
              currentPos.lat.toFixed(6) !== lat.toFixed(6) ||
              currentPos.lng.toFixed(6) !== lng.toFixed(6)
            ) {
              this.marker.setLatLng(latlng);
              this.map.panTo(latlng);
            }
          } else {
            this.createMarker(lat, lng);
            this.map.setView(latlng, 15);
          }
        }
      }
    },
  },

  methods: {
    addSosmed() {
      this.editedItem.sosmed.push({ platform: "instagram", url: "" });
    },
    removeSosmed(index) {
      this.editedItem.sosmed.splice(index, 1);
    },

    createMarker(lat, lng) {
      if (this.marker) this.map.removeLayer(this.marker);
      this.marker = L.marker([lat, lng], {
        draggable: true,
        icon: L.divIcon({
          className: "custom-div-icon",
          html: `<div style="background-color:#CFA22D; width:18px; height:18px; border-radius:50%; border:2px solid white; box-shadow:0 0 15px #CFA22D; cursor:move;"></div>`,
          iconSize: [18, 18],
          iconAnchor: [9, 9],
        }),
      }).addTo(this.map);

      this.marker.on("dragend", (e) => {
        const { lat, lng } = e.target.getLatLng();
        this.editedItem.latlong = `${lat.toFixed(6)},${lng.toFixed(6)}`;
      });
    },

    initMap() {
      setTimeout(() => {
        const defaultPos = [-7.9135, 113.8215];
        this.map = L.map("map-opd", { zoomControl: false }).setView(defaultPos, 13);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(this.map);
        L.control.zoom({ position: "bottomright" }).addTo(this.map);

        this.map.on("click", (e) => {
          const { lat, lng } = e.latlng;
          this.editedItem.latlong = `${lat.toFixed(6)},${lng.toFixed(6)}`;
          this.createMarker(lat, lng);
        });
      }, 500);
    },

    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/opd`);
        if (res.data && res.data.response) {
          this.opdList = res.data.response.data || [];
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    onFileChange(file) {
      if (file) {
        this.imageFile = file;
        this.imageUrl = URL.createObjectURL(file);
      }
    },

    editItem(item) {
      let parsedSosmed = [];
      if (item.sosmed) {
        if (typeof item.sosmed === "string") {
          try {
            parsedSosmed = JSON.parse(item.sosmed);
          } catch (e) {
            parsedSosmed = [];
          }
        } else if (Array.isArray(item.sosmed)) {
          parsedSosmed = item.sosmed;
        }
      }

      this.editedItem = Object.assign({}, item, { sosmed: parsedSosmed });

      if (this.editedItem.latlong) {
        const pos = this.editedItem.latlong.split(",");
        const lat = parseFloat(pos[0]);
        const lng = parseFloat(pos[1]);
        this.createMarker(lat, lng);
        this.map.setView([lat, lng], 16);
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    async save() {
      if (!this.editedItem.nama_opd) return alert("Identitas OPD wajib diisi!");
      this.loading = true;

      const formData = new FormData();
      formData.append("nama_opd", this.editedItem.nama_opd);
      formData.append("deskripsi", this.editedItem.deskripsi || "");
      formData.append("alamat_kantor", this.editedItem.alamat_kantor || "");
      formData.append("latlong", this.editedItem.latlong || "");
      formData.append("is_active", this.editedItem.is_active);

      formData.append("sosmed", JSON.stringify(this.editedItem.sosmed || []));

      if (this.imageFile) formData.append("foto", this.imageFile);

      try {
        if (this.editedItem.id) {
          await axios.put(`${BASE_URL}/opd/${this.editedItem.id}`, formData);
        } else {
          await axios.post(`${BASE_URL}/opd`, formData);
        }
        this.fetchData();
        this.clearForm();
        alert("Sinkronisasi Berhasil!");
      } catch (e) {
        alert("Gagal menyambungkan ke server!");
      } finally {
        this.loading = false;
      }
    },

    clearForm() {
      this.editedItem = Object.assign({}, this.defaultItem, { sosmed: [] });
      this.imageFile = null;
      this.imageUrl = null;
      if (this.marker) this.map.removeLayer(this.marker);
    },

    async deleteItem(item) {
      if (confirm("Hapus data unit ini dari sistem?")) {
        try {
          await axios.delete(`${BASE_URL}/opd/${item.id}`);
          this.fetchData();
        } catch (e) {
          alert("Gagal menghapus!");
        }
      }
    },
  },
};
</script>

<style scoped>
.cyber-page {
  background: transparent;
}
.cyber-text {
  letter-spacing: 2px !important;
  color: white !important;
  text-shadow: 0 0 10px rgba(1, 140, 116, 0.5);
}
.secondary-text {
  color: #cfa22d !important;
}
.opacity-7 {
  opacity: 0.7;
}

.glass-card {
  background: rgba(0, 26, 22, 0.8) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5) !important;
}

.cyber-sosmed-header {
  font-size: 11px;
  letter-spacing: 1px;
  border-bottom: 1px dashed rgba(207, 162, 45, 0.3);
  padding-bottom: 4px;
}
.cyber-add-sosmed-btn {
  border: 1px dashed #cfa22d !important;
  font-weight: bold;
}
.cyber-select-dense >>> .v-input__control,
.cyber-input-dense >>> .v-input__control {
  background: rgba(0, 0, 0, 0.2) !important;
}

.map-wrapper {
  position: relative;
  padding: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #cfa22d;
}
.cyber-map-container {
  height: 450px;
  width: 100%;
  border-radius: 4px;
}
.light-map {
  filter: none !important;
}

.cyber-save-btn {
  color: #002616 !important;
  font-weight: 900 !important;
}
.cyber-coord-field >>> input {
  color: #cfa22d !important;
  font-weight: bold;
}

.cyber-search-field >>> .v-input__control {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(207, 162, 45, 0.3);
}

.cyber-table {
  background: transparent !important;
}
.cyber-table >>> th {
  background: rgba(1, 140, 116, 0.1) !important;
  color: #cfa22d !important;
  font-weight: bold;
  border-bottom: 2px solid #018c74 !important;
}
.table-img-frame {
  padding: 2px;
  border: 1px solid rgba(1, 140, 116, 0.5);
  display: inline-block;
}
.shadow-glow {
  box-shadow: 0 0 8px rgba(1, 140, 116, 0.4);
}
.glow-on-hover:hover {
  filter: drop-shadow(0 0 5px currentColor);
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
